import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import DefaultForm from '../DefaultForm'
import Loading from '@ublique/components/Loading'
import 'pages/Administration/components/index.scss'
import {
  handleInstanceInsertion,
  notifySuccess,
  processInstanceValidation,
  processRoleValidation
} from 'pages/Administration/Tabs/Instances/helpers'
import { createInstanceApi } from 'services/api/administration/instances'
import { openModal } from 'components/Modal/actions'

const InstanceModal = ({ open, close, data }) => {
  const { t } = useTranslation(['Administration', 'Common'])
  const { instanceType, exsistingInstance, allInstances, roles, gridApi } = data
  const defaultInstance = { instance: {}, role: {}, permissions: [] }
  const [newValue, setNewValue] = useState(defaultInstance)

  const { updateInstancePermissionsBulk } = useMemo(
    () => createInstanceApi(instanceType),
    [instanceType]
  )
  const [isInstanceInvalid, setIsInstanceInvalid] = useState(false)
  const [isRoleInvalid, setIsRoleInvalid] = useState(false)
  const [isFormInvalid, setIsFormInvalid] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  function getPayload(element) {
    const permissionPayload = {
      read: false,
      import_: false,
      export: false,
      create: false,
      update: false,
      delete: false
    }
    element.permissions.forEach((permission) => {
      permissionPayload[permission.text] = true
    })
    const payload = {
      instanceId: element.instance.value,
      permissions: [
        {
          permission: permissionPayload,
          roleName: element.role.value
        }
      ]
    }
    return payload
  }

  useEffect(() => {
    setIsFormInvalid(isRoleInvalid || isInstanceInvalid)
  }, [isRoleInvalid, isInstanceInvalid])

  const addInstaceRolePair = async (isBulk) => {
    const payload = getPayload(newValue)

    setIsLoading(true)

    try {
      if (isBulk) {
        await updateInstancePermissionsBulk(payload)
      }
      gridApi.deselectAll()
      // setSelectedRows([])
      notifySuccess('Add', t)
    } catch (err) {
      console.error(err)
      close()
    }

    close()
    setIsLoading(false)
  }

  const onOverwriteModalSubmit = () => {
    addInstaceRolePair(true)
  }

  const onAddPrimaryModalSubmit = async () => {
    const role = processRoleValidation(newValue, setIsRoleInvalid)
    const instance = processInstanceValidation(newValue, setIsInstanceInvalid)
    if (role || instance) return

    if (
      exsistingInstance.filter(
        (i) =>
          i.roleName === newValue.role.label &&
          i.title === newValue.instance.label
      ).length !== 0
    ) {
      openModal('confirmAction', {
        modalHeading: t('Common:OverwriteInstance'),
        message: t('Common:InstanceOverwriteConfirmation'),
        onConfirm: onOverwriteModalSubmit,
        primaryButtonText: t('Common:Overwrite'),
        secondaryButtonText: t('Common:Cancel'),
        loadingOverlay: true
      })
    } else {
      addInstaceRolePair(true)
    }
  }

  const handleOnAddChange = useCallback(
    (value) => {
      setNewValue((prevState) => ({ ...prevState, ...value }))
      processRoleValidation(value, setIsRoleInvalid)
      processInstanceValidation(value, setIsInstanceInvalid)
    },
    [newValue]
  )

  return (
    <Modal
      open={open}
      id='selectedRowsLength'
      preventCloseOnClickOutside
      className='admin-view'
      modalHeading={t(`Administration:RolesManagement.InstancesModal.Title`)}
      primaryButtonText={t('Common:Save')}
      secondaryButtonText={t('Common:Cancel')}
      iconDescription={t('Common:Close')}
      primaryButtonDisabled={isFormInvalid}
      onRequestSubmit={onAddPrimaryModalSubmit}
      onRequestClose={close}
      onSecondarySubmit={close}
    >
        {isLoading && <Loading description='Loading' withOverlay />}
        <DefaultForm
          formFields={handleInstanceInsertion(
            handleOnAddChange,
            newValue,
            allInstances || [],
            roles || [],
            isRoleInvalid,
            isInstanceInvalid
          )}
          t={t}
        />
    </Modal>
  )
}

export default InstanceModal
